// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_27-1";
export var movingGradient = "_27-4";
export var movingGradientBlock = "_27-2";
export var skeleton = "_27-0";
export var skeletonText = "_27-3";